import * as queryString from 'query-string';
import useRouter from 'use-react-router';
import { isWelcomerKind, UIFilterWelcomerKindType } from './types';

const parseKind = (search: string): UIFilterWelcomerKindType => {
  const { kind } = queryString.parse(search);
  return isWelcomerKind(kind) ? kind : 'instagram_welcomer';
};

export const useWelcomerFilter = () => {
  const { history, location } = useRouter();
  const { search } = location;
  const activeKind = parseKind(search);

  const setSearchParams = (params: Record<string, any>) => {
    const searchParams = queryString.parse(search);
    history.push({
      ...location,
      search: queryString.stringify({ ...searchParams, ...params }),
    });
  };

  const setFilterKind = (kind?: UIFilterWelcomerKindType) =>
    setSearchParams({ kind });

  return {
    activeKind,
    setFilterKind,
  };
};
